module.exports = __webpack_public_path__ + "assets/img/bg3.9d937c52.gif";